export default __webpack_public_path__ + "static/media/playstore.501f0872.png";